/**
 * Meta Pixel tracking utilities
 * Tracks conversion events for Facebook advertising
 */

// Type definition for fbq function
declare global {
  interface Window {
    fbq?: (
      action: string,
      eventName: string,
      params?: Record<string, unknown>
    ) => void;
  }
}

/**
 * Track a Lead event when a brand new user signs up (first-time only).
 * Only called when is_new_user is true from the backend - NOT for returning logins.
 * @param params - Optional parameters for the Lead event
 */
export function trackLead(params?: {
  authMethod?: 'wallet' | 'privy' | null;
  walletType?: string;
  email?: string | null;
}) {
  if (typeof window.fbq === 'function') {
    console.log('[MetaPixel] Tracking Lead event:', params);
    window.fbq('track', 'Lead', params);
  } else {
    console.warn('[MetaPixel] fbq not available - Lead event not tracked');
  }
}

/**
 * Track a custom event
 * @param eventName - Custom event name
 * @param params - Event parameters
 */
export function trackCustomEvent(
  eventName: string,
  params?: Record<string, unknown>
) {
  if (typeof window.fbq === 'function') {
    console.log(`[MetaPixel] Tracking ${eventName} event:`, params);
    window.fbq('trackCustom', eventName, params);
  } else {
    console.warn(`[MetaPixel] fbq not available - ${eventName} event not tracked`);
  }
}

